import { render, staticRenderFns } from "./EVMBlock.vue?vue&type=template&id=1950ebb6&scoped=true&"
import script from "./EVMBlock.vue?vue&type=script&lang=ts&"
export * from "./EVMBlock.vue?vue&type=script&lang=ts&"
import style0 from "./EVMBlock.vue?vue&type=style&index=0&id=1950ebb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1950ebb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs})
